import { createTheme } from '@mui/material/styles';

export const customTheme = createTheme({
    palette: {
        primary: {
            main: '#4F78AE',
            light: '#7A9BC7',
            dark: '#3A5B89',
            contrastText: '#ffffff'
        },
        secondary: {
            main: '#C2895A',
            light: '#D4A474',
            dark: '#A36D3F',
            contrastText: '#ffffff'
        },
        background: {
            default: '#ffffff',
            paper: '#ffffff'
        },
        text: {
            primary: '#000000',
            secondary: '#4F78AE'
        },
        divider: '#C2895A',
        success: {
            main: '#4F78AE',
            contrastText: '#ffffff'
        },
        warning: {
            main: '#C2895A',
            contrastText: '#ffffff'
        },
        error: {
            main: '#C2895A',
            contrastText: '#ffffff'
        }
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h4: {
            fontWeight: 600,
            color: '#000000'
        },
        h5: {
            fontWeight: 600,
            color: '#4F78AE'
        },
        h6: {
            fontWeight: 500,
            color: '#4F78AE'
        }
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 2px 8px rgba(79, 120, 174, 0.1)',
                    border: '1px solid rgba(194, 137, 90, 0.2)',
                    borderRadius: 8
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 500,
                    borderRadius: 6
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: 500
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: ({ theme }) => ({
                    '&.parent-menu': {
                        backgroundColor: 'rgba(79, 120, 174, 0.05)',
                        borderLeft: '3px solid',
                        borderLeftColor: theme.palette.primary.light,
                        borderRadius: theme.spacing(2),
                        margin: theme.spacing(0.5, 1),
                        minHeight: 52,
                        fontWeight: 600,
                        transition: 'all 0.2s ease-in-out',
                        
                        '&:hover': {
                            backgroundColor: 'rgba(79, 120, 174, 0.1)',
                            transform: 'translateX(2px)',
                            boxShadow: '0 2px 8px rgba(79, 120, 174, 0.15)',
                        },
                        
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(79, 120, 174, 0.15)',
                            borderLeftColor: theme.palette.primary.main,
                            borderLeftWidth: '4px',
                            
                            '&:hover': {
                                backgroundColor: 'rgba(79, 120, 174, 0.2)',
                            },
                        },
                        
                        '& .MuiListItemIcon-root': {
                            color: theme.palette.primary.dark,
                            marginRight: theme.spacing(2.5),
                            
                            '& svg': {
                                fontSize: '24px',
                            },
                        },
                        
                        '& .MuiListItemText-primary': {
                            fontWeight: 600,
                            fontSize: '0.95rem',
                            letterSpacing: '0.02em',
                        },
                        
                        '&.Mui-selected .MuiListItemIcon-root': {
                            color: theme.palette.primary.main,
                        },
                        
                        '&.Mui-selected .MuiListItemText-primary': {
                            color: theme.palette.primary.main,
                            fontWeight: 700,
                        },
                    },
                    
                    '&.child-menu': {
                        backgroundColor: 'rgba(194, 137, 90, 0.03)',
                        borderLeft: '2px solid',
                        borderLeftColor: theme.palette.secondary.light,
                        borderRadius: theme.spacing(1.5),
                        margin: theme.spacing(0.25, 1.5),
                        minHeight: 44,
                        paddingLeft: theme.spacing(4),
                        fontWeight: 500,
                        transition: 'all 0.2s ease-in-out',
                        
                        '&:hover': {
                            backgroundColor: 'rgba(194, 137, 90, 0.08)',
                            transform: 'translateX(4px)',
                            boxShadow: '0 1px 4px rgba(194, 137, 90, 0.15)',
                        },
                        
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(194, 137, 90, 0.12)',
                            borderLeftColor: theme.palette.secondary.main,
                            borderLeftWidth: '3px',
                            
                            '&:hover': {
                                backgroundColor: 'rgba(194, 137, 90, 0.15)',
                            },
                        },
                        
                        '& .MuiListItemIcon-root': {
                            color: theme.palette.secondary.dark,
                            marginRight: theme.spacing(2),
                            
                            '& svg': {
                                fontSize: '20px',
                            },
                        },
                        
                        '& .MuiListItemText-primary': {
                            fontWeight: 500,
                            fontSize: '0.875rem',
                            letterSpacing: '0.01em',
                        },
                        
                        '&.Mui-selected .MuiListItemIcon-root': {
                            color: theme.palette.secondary.main,
                        },
                        
                        '&.Mui-selected .MuiListItemText-primary': {
                            color: theme.palette.secondary.main,
                            fontWeight: 600,
                        },
                    },
                }),
            },
        },
        MuiCollapse: {
            styleOverrides: {
                root: {
                    '& .MuiCollapse-wrapper': {
                        '& .MuiCollapse-wrapperInner': {
                            paddingLeft: 0,
                        },
                    },
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    '&[role="menu"]': {
                        paddingTop: 4,
                        paddingBottom: 4,
                    },
                },
            },
        },
    }
});